<template>
  <div class="ward-settings">
    <div class="header">
      <h2>🏥 Ward Settings</h2>
      <button class="btn-add" @click="openAddWard">+ Add New Ward</button>
    </div>

    <table class="ward-table">
      <thead>
        <tr>
          <th>#</th>
          <th>Ward Name</th>
          <th>Ward Type</th>
          <th>Capacity</th>
          <th>Status</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(ward, index) in wards" :key="ward.id">
          <td>{{ index + 1 }}</td>
          <td>{{ ward.ward_name }}</td>
          <td>{{ ward.type_name }}</td>
          <td>{{ ward.capacity }}</td>
          <td>
            <span :class="ward.status == 'active' ? 'active' : 'inactive'">
              {{ ward.status == "active" ? "Active" : "Inactive" }}
            </span>
          </td>
          <td>
            <button class="btn-edit" @click="openEditWard(ward)">Edit</button>
            <button class="btn-delete" @click="deleteWard(ward.id)">
              Delete
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <CreateWardModal
    v-if="showWardModal"
    :wardToEdit="selectedWard"
    @close-add-ward="showWardModal = false"
  />
</template>

<script>
import { generalApiRequest } from "../../../api/apiIndex";
import CreateWardModal from "./create_ward_modal.vue";
export default {
  name: "WardSettings",
  data() {
    return {
      showWardModal: false,
      selectedWard: null,
      wards: [],
    };
  },
  components: {
    CreateWardModal,
  },
  methods: {
    async getCompanyWard() {
      const url = "inpatient/getCompanyWards";
      const data = await generalApiRequest(url, "GET", {}, 1);
      this.wards = data;
    },
    deleteWard(id) {
      if (confirm("Are you sure you want to delete this ward?")) {
        this.wards = this.wards.filter((ward) => ward.id !== id);
      }
    },

    //
    openAddWard() {
      this.selectedWard = null;
      this.showWardModal = true;
    },
    openEditWard(ward) {
      this.selectedWard = ward;
      this.showWardModal = true;
    },
    handleWardSave(data) {
      if (this.selectedWard) {
        console.log("Updating ward:", data);
        // send PUT/PATCH request
      } else {
        console.log("Creating new ward:", data);
        // send POST request
      }
      this.showWardModal = false;
    },
    //
  },
  mounted() {
    this.getCompanyWard();
  },
};
</script>

<style scoped>
.ward-settings {
  padding: 1.5rem;
  font-family: Arial, sans-serif;
  color: #333;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
}

.header h2 {
  font-size: 1.5rem;
}

.btn-add {
  background: #2786f7;
  color: #fff;
  padding: 0.5rem 1rem;
  border: none;
  border-radius: 0.3rem;
  font-size: 0.9rem;
  cursor: pointer;
}

.ward-table {
  width: 100%;
  border-collapse: collapse;
}

.ward-table th,
.ward-table td {
  border: 1px solid #ddd;
  padding: 0.6rem;
  text-align: center;
  font-size: 0.95rem;
}

.ward-table th {
  background: #f5f5f5;
  font-weight: 600;
}

.ward-table tr:nth-child(even) {
  background: #fafafa;
}

.active {
  color: #1e7c1e;
  font-weight: 600;
}

.inactive {
  color: #e31919;
  font-weight: 600;
}

.btn-edit,
.btn-delete {
  padding: 0.35rem 0.7rem;
  border: none;
  border-radius: 0.25rem;
  cursor: pointer;
  font-size: 0.85rem;
}

.btn-edit {
  background: #2786f7;
  color: #fff;
  margin-right: 0.4rem;
}

.btn-delete {
  background: #e31919;
  color: #fff;
}
</style>
